import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  connect() {
    const { message } = this.element.dataset;
    const type = this.element.dataset.type === 'danger' ? 'danger' : 'success'; // danger以外はすべてsuccess扱い
    $.notify({ message }, { type });
  }
}
